import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { School } from '@propertypal/shared/src/types/schools';
import getAnchor from '@propertypal/shared/src/utils/ui/anchor';
import React, { CSSProperties, FunctionComponent, useEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import Chevron from '../icons/Chevron';
import { LinkText } from '../typography';
import { InfoClose, InfoPopup, InfoTitle } from './InfoBox.style';

interface Props {
  type: string;
  school: School;
  onClose: () => void;
  target: HTMLElement;
  offsetTop?: number;
}

const TITLES: { [key: string]: string } = {
  applications: 'TOTAL APPLICATIONS FOR PREVIOUS SCHOOL YEARS',
  admissions: 'TOTAL ADMISSIONS FOR PREVIOUS SCHOOL YEARS',
  totalPupils: 'TOTAL PUPILS FOR PREVIOUS SCHOOL YEARS',
};

const InfoBox: FunctionComponent<Props> = (props) => {
  const theme = useTheme();
  const container = useRef<HTMLDivElement>(null);
  const [anchor, setAnchor] = useState('');
  const [style, setStyle] = useState<CSSProperties>();

  useEffect(() => {
    const [mAnchor, mStyle] = getAnchor(props.target, container, props.offsetTop);
    setStyle(mStyle);
    setAnchor(mAnchor);
  }, [props.target]);

  return (
    <InfoPopup className="pp-schools-info-box" ref={container} anchor={anchor} style={style} data-testid="info-popup">
      <InfoClose onClick={props.onClose}>
        <FontAwesomeIcon color={theme.textDark} icon={faTimes} style={{ fontSize: 14 }} />
      </InfoClose>

      <InfoTitle className="pp-schools-info-box-title">
        {props.type === 'details' && props.school.name}
        {props.type !== 'details' && TITLES[props.type]}
      </InfoTitle>

      {props.type === 'details' && (
        <>
          <p>{props.school.fullAddress}</p>
          <p>
            <b>{props.school.phoneNumber}</b>
          </p>

          <p>
            <LinkText href={props.school.websiteUrl} target="_blank">
              View website <Chevron size={10} />
            </LinkText>
          </p>
        </>
      )}

      {props.type === 'applications' && (
        <ul>
          {props.school.years.map((year) => (
            <li key={year.year}>
              <b>{year.year}</b> {year.totalApplications}
            </li>
          ))}
        </ul>
      )}

      {props.type === 'admissions' && (
        <ul>
          {props.school.years.map((year) => (
            <li key={year.year}>
              <b>{year.year}</b> {year.totalAdmissions}
            </li>
          ))}
        </ul>
      )}

      {props.type === 'totalPupils' && (
        <ul>
          {props.school.years.map((year) => (
            <li key={year.year}>
              <b>{year.year}</b> {year.totalPupilsROI}
            </li>
          ))}
        </ul>
      )}
    </InfoPopup>
  );
};

export default InfoBox;
